var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "d-flex align-items-center small" }, [
    _c(
      "div",
      { staticClass: "flex-fill d-flex align-items-center" },
      [
        _c(
          "div",
          { staticClass: "dropup ms-1 p-1" },
          [
            _c(
              _setup.Button,
              {
                staticClass: "btn-sm",
                attrs: { "data-bs-toggle": "dropdown" },
              },
              [_c("i", { staticClass: "bi-three-dots" })]
            ),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "dropdown-menu",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c(
                  "li",
                  { staticClass: "dropdown-item text-center" },
                  [_c(_setup.CodemirrorModeMenu)],
                  1
                ),
                _vm._v(" "),
                _c(_setup.CodemirrorLineNumbersBtn),
                _vm._v(" "),
                _c(_setup.CodemirrorLineWrappingBtn),
                _vm._v(" "),
                _c(_setup.CodemirrorTwigModeBtn),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _setup.isContentType
          ? _c(_setup.ThemesEditorContentTypeFieldsBtn, {
              attrs: { id: _vm.editor.id },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex align-items-center" },
      [
        _c("small", { staticClass: "me-1 text-body-secondary" }, [
          _c(
            "strong",
            [
              _setup.item
                ? _c("Timeago", {
                    attrs: {
                      datetime:
                        (_setup.item.modifiedDate || _setup.item.createdDate) *
                        1000,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v("\n            by\n            "),
          _c(
            "strong",
            { staticClass: "text-secondary" },
            [
              _setup.modifiedBy
                ? _c(_setup.UserName, {
                    attrs: {
                      id: _setup.modifiedBy,
                      "no-user-found-str": "user not found",
                      "no-user-str": "system",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          _setup.Button,
          {
            staticClass: "me-1 btn-sm",
            attrs: {
              "active-value": _vm.editor.isModified,
              "active-class": "btn-warning",
            },
            nativeOn: {
              click: function ($event) {
                return _vm.saveEditor.apply(null, arguments)
              },
            },
          },
          [_c("i", { staticClass: "bi-save" })]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }